import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import { togglePriceGap } from '../../redux/actions/priceGap/togglePriceGap';
import { updatePriceGap } from '../../redux/actions/priceGap/updatePriceGap';

class UpdatePriceGapModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate(values,
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Price Gaps"
                key={this.props.priceGap?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-priceGap-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-priceGap-form"
                    name="basic"
                    initialValues={{
                        bodyGap:this.props.priceGap?.bodyGap,
                        goalGap:this.props.priceGap?.goalGap,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="bodyGap"
                        label="BodyGap"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="goalGap"
                        label="Goal Gap"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber />
                    </Form.Item>
                    
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.priceGap.updateVisible,
    loading: state.priceGap.loading,
    token: state.auth.token,
    error: state.priceGap.error,
    message: state.priceGap.message,
    priceGap: state.priceGap.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (obj, token) => dispatch(updatePriceGap(obj, token)),
    onClose: () => dispatch(togglePriceGap()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePriceGapModal);